/**
 * @desc login
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.login.login.Params, options?: any) {
  return updateResponse(
    http(URL + `/login`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
